<template>
  <div>
    <div class="modal-form">
      <div class="hint">{{ $t("contactForm.hint") }}</div>
      <div class="form-body">
        <div class="check-list">
          <div v-for="item in checkList" :key="item.id" class="check-list-item">
            <input
              @change="error = false"
              v-model="checked"
              :id="item.id"
              :value="item.label"
              type="checkbox"
            />
            <label :for="item.id"></label>
            {{ item.label }}
          </div>
        </div>
        <div v-show="error" class="error">{{ $t("contactForm.checkList.error") }}</div>
      </div>
    </div>
    <div class="main-footer">
      <Button @click="next" size="small">{{ $t("contactForm.button.submit") }}</Button>
    </div>
  </div>
</template>

<script>
import Button from "../../Button/button.desktop";
import "../assets/index.desktop.scss";

export default {
  components: { Button },
  data() {
    return {
      error: false,
      checked: [],
      checkList: [
        {
          id: "item1",
          label: this.$t("contactForm.checkList.list")[0],
        },
        {
          id: "item2",
          label: this.$t("contactForm.checkList.list")[1],
        },
        {
          id: "item3",
          label: this.$t("contactForm.checkList.list")[2],
        },
      ],
    };
  },
  methods: {
    next() {
      if (this.checked.length === 0) {
        this.error = true;
        return undefined;
      }
      this.$emit("nextForm", "first", this.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-footer {
  margin-top: 140px;
  display: flex;
  justify-content: flex-end;
}

.form-body {
  position: relative;

  .check-list {
    &-item {
      display: flex;
      text-align: left;
      // padding-left: 16px;
      align-items: center;
      @media screen and(max-width: 450px) {
        align-items: flex-start;

        label {
          overflow: hidden;
        }
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  .error {
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    /* identical to box height */
    position: absolute;
    bottom: -17px;
    color: #d62d2d;
    margin-top: 17px;
    text-align: left;
  }
}

/deep/ input[type="checkbox"] {
  display: none;
}
/deep/ label {
  display: block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  cursor: pointer;
  margin-right: 5px;
  // position: absolute;
  border: 1px solid #ccc; /*改变复选框的边框颜色也可以不要边框*/

  @media screen and(max-width: 450px) {
    width: 16px;
    height: 16px;
    margin-top: 4px;
  }
  // top: 6px;
}
/deep/ input:checked + label {
  border-color: #c2a061;
  &:before {
    /*before为伪元素可以在元素之后添加内容*/
    display: block;
    content: "\2713";
    text-align: center;
    // font-size: #000;
    color: #000;
    background: linear-gradient(135deg, #d3be8c 0%, #c2a061 100%);
  }
}
</style>
